import { requireConvexSiteUrl } from '@/lib/convex-site-url';

const PENDING_SIGNUP_PAGE_TOKEN_KEY = 'signup.pageToken';

const getConvexSiteUrl = (): string =>
  requireConvexSiteUrl(
    process.env.NEXT_PUBLIC_CONVEX_SITE_URL,
    process.env.NEXT_PUBLIC_CONVEX_URL
  );

export function setPendingSignupPageToken(token: string) {
  try {
    localStorage.setItem(PENDING_SIGNUP_PAGE_TOKEN_KEY, token.trim());
  } catch {}
}

export function getPendingSignupPageToken(): string | null {
  try {
    const token = localStorage.getItem(PENDING_SIGNUP_PAGE_TOKEN_KEY);
    return token?.trim() || null;
  } catch {
    return null;
  }
}

export function clearPendingSignupPageToken() {
  try {
    localStorage.removeItem(PENDING_SIGNUP_PAGE_TOKEN_KEY);
  } catch {}
}

export async function issuePendingSignupPageToken(slug: string) {
  const formData = new FormData();
  formData.set('slug', slug.trim());

  const response = await fetch(`${getConvexSiteUrl()}/signup-page-token`, {
    method: 'POST',
    body: formData,
  });

  const payload = (await response.json().catch(() => null)) as {
    token?: string;
    expiresAt?: number;
    error?: string;
  } | null;

  if (!response.ok || !payload?.token) {
    throw new Error(payload?.error || 'Failed to issue signup page token');
  }

  return {
    token: payload.token,
    expiresAt: payload.expiresAt ?? null,
  };
}
